import styled from "@emotion/styled";
import { Box } from "@mui/material";

export const ContentLeftSide = styled(Box)`
  @media only screen and (min-width: 600px) {
    & {
      width: 50% !important;
    }
  }
  width: 100%;
`;

export const ContentRightSide = styled(Box)`
  @media only screen and (min-width: 600px) {
    & {
      width: 50% !important;
      display: unset !important;
    }
  }
  display: none;
`;
